import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FormInterceptor implements HttpInterceptor {
    constructor() { }

    object2params(obj) {
        if (obj) {
            return Object.keys(obj).map(x => {
                let val = obj[x];
                if (typeof val !== 'string') {
                    val = JSON.stringify(val);
                }
                return x + '=' + val;
            }).join('&');
        }
        return '';
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers = req.headers
            .set('Content-Type', 'application/x-www-form-urlencoded');
        let body = null;
        // let params = null;
        if (req.method === 'POST') {
            body = this.object2params(req.body);
        }
        // else if (req.method === 'GET') {
        //     params = req.params.append('date', new Date().getTime() + '');
        // }
        const newReq = req.clone({
            headers: headers,
            body: body
            // params: params
        });
        return next.handle(newReq);
    }
}

@Injectable()
export class JsonInterceptor implements HttpInterceptor {
    constructor() { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers = req.headers
            .set('Content-Type', 'application/json');
        const newReq = req.clone({
            headers: headers
        });
        return next.handle(newReq);
    }
}

export const HttpSetParamProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: FormInterceptor,
    multi: true
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/implements/setParam.interceptor.ts